import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "page has-compressed-header" }
const _hoisted_2 = {
  key: 2,
  class: "section primary-header"
}
const _hoisted_3 = { class: "level container is-fluid" }
const _hoisted_4 = { class: "level-left" }
const _hoisted_5 = { class: "title is-4 answer-title" }
const _hoisted_6 = { class: "flow-status is-flex" }
const _hoisted_7 = { class: "level-right" }
const _hoisted_8 = { class: "level-item" }
const _hoisted_9 = { class: "button-content" }
const _hoisted_10 = { class: "level-item" }
const _hoisted_11 = { class: "button-content" }
const _hoisted_12 = { class: "button-content" }
const _hoisted_13 = { class: "level-item" }
const _hoisted_14 = { class: "button-content" }
const _hoisted_15 = { class: "level-item" }
const _hoisted_16 = { class: "question-answer-container" }
const _hoisted_17 = { class: "questions-container" }
const _hoisted_18 = { class: "question-list" }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "answer-container" }
const _hoisted_21 = { class: "answer" }
const _hoisted_22 = { class: "state-menu" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "cube-icon" }
const _hoisted_25 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { class: "state-menu" }
const _hoisted_28 = ["onClick"]

import { answersApi } from '../services/answers';
import { QuestionViewModel } from '../models/answers/questionViewModel';
import { nanoid } from 'nanoid';
import DeleteIcon from 'vue-material-design-icons/TrashCanOutline.vue';
import EditableText from '@/shared/components/EditableText.vue';
import Toast from '@/shared/services/toast';
import Draggable from 'vuedraggable';
import { StateViewModel } from '../models/designer';
import DropDownMenu from '@/shared/components/dropDownMenu/DropDownMenu.vue';
import TextIcon from 'vue-material-design-icons/FormatTitle.vue';
import GoToIcon from '@/shared/icons/GoToIcon.vue';
import ConfirmationModal from '@/shared/components/ConfirmationModal.vue';
import UtteranceList from '@/features/bots/components/designer/UtteranceList.vue';
import HtmlFormatter from '@/shared/services/htmlFormatter';
import { AnswerViewModel } from '@/features/bots/models/answers/answerViewModel';
import { FlowStatus } from '@/features/bots/models/flowStatus';
import BackArrow from 'vue-material-design-icons/ArrowLeft.vue';
import SaveIcon from 'vue-material-design-icons/ContentSave.vue';
import PauseIcon from 'vue-material-design-icons/Pause.vue';
import PlayIcon from 'vue-material-design-icons/Play.vue';
import appInsights from '@/shared/services/appInsights';
import BotPreviewModal from '@/features/bots/components/botTestTool/BotPreviewModal.vue';
import { BOT_STUDIO_ENABLED } from '@/store/app/featureTypes';
import AdvancedTooltip from '@/shared/components/AdvancedTooltip.vue';
import UpgradeModal from '@/features/bots/components/UpgradeModal.vue';
import FaqIntentPicker from '@/features/bots/components/FaqIntentPicker.vue';
import { CREATE_INTENT, GET_INTENT, LOAD_INTENTS, UPDATE_INTENT } from '@/store/intents/actionTypes';
import { IntentViewModel } from '../models/intents/intentViewModel';
import { SaveIntentViewModel } from '../models/intents/saveIntentViewModel';
import { IntentListItemViewModel } from '../models/intents/intentListItemViewModel';
import { LOAD_ANSWER, UPDATE_ANSWER } from '@/store/answers/actionTypes';
import { UpdateAnswerViewModel } from '../models/answers/updateAnswerViewModel';
import { useStore } from 'vuex';
import { computed, nextTick, onBeforeUnmount, onMounted, ref } from 'vue';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { useRoute, useRouter, onBeforeRouteLeave, RouteLocationNormalized } from 'vue-router';
import TextComponent from '@/features/bots/components/designer/TextComponent.vue';
import AppIntegrationComponent from '@/features/bots/components/designer/AppIntegrationComponent.vue';
import GoToComponent from '@/features/bots/components/designer/GoToComponent.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'AnswerEditor',
  setup(__props) {

const COMPONENTS = {
  TextComponent,
  AppIntegrationComponent,
  GoToComponent,
};

const validIntentName = (value: string) => {
  return value.search(/[<>*%&:\\$]/) === -1;
};

const router = useRouter();
const route = useRoute();

const store = useStore();
const currentWorkspace = computed(() => store.getters.currentWorkspace);
const isWorkspaceFeatureEnabled = (feature: string) => computed(() => store.getters.isWorkspaceFeatureEnabled(feature));
const isAnswerTransitioningToAnInactiveFlow = computed(() => store.getters.isAnswerTransitioningToAnInactiveFlow);

const loadAnswer = (answerId: string): Promise<AnswerViewModel> => store.dispatch(LOAD_ANSWER, answerId);
const updateAnswer = (answerId: string, request: UpdateAnswerViewModel): Promise<AnswerViewModel> =>
  store.dispatch(UPDATE_ANSWER, { answerId, request });
const getIntent = (id: string): Promise<IntentViewModel> => store.dispatch(GET_INTENT, id);
const createIntent = (intent: SaveIntentViewModel): Promise<IntentViewModel> => store.dispatch(CREATE_INTENT, intent);
const updateIntent = (id: string, intent: SaveIntentViewModel): Promise<IntentViewModel> =>
  store.dispatch(UPDATE_INTENT, { id, intent });
const loadIntents = (forceLoad: boolean = false): Promise<IntentListItemViewModel[]> =>
  store.dispatch(LOAD_INTENTS, forceLoad);

const questions = ref<QuestionViewModel[]>([]);
const faqName = ref('');
const currentAnswerStatus = ref<FlowStatus>(FlowStatus.Draft);
const hasMadeChanges = ref(false);
const hasLiveParentFlows = ref(false);
const isSaveInProgress = ref(false);
const loadedAnswer = ref(false);
const loadedFullIntent = ref(false);
const loadedIntentList = ref(false);
const isStatePickerUp = ref(false);
const intentId = ref<string>();
const intent = ref<Partial<IntentViewModel>>();
const intents = ref<IntentListItemViewModel[]>([]);
const showLeaveModal = ref(false);
const showDeleteModal = ref(false);
const showMakeLiveModal = ref(false);
const showBotPreviewModal = ref(false);
const showPauseAnswerModal = ref(false);
const showUpgradeModal = ref(false);
const existingAnswer = ref<AnswerViewModel>();
let navigationNext: ((value?: boolean) => void) | null = null; // Store the next callback
const discardModal = ref<typeof ConfirmationModal | null>(null);

const answerStates = ref<StateViewModel[]>([]);

const endStates = computed<StateViewModel[]>(
  () => answerStates.value.filter((s: StateViewModel) => s.component === 'GoTo') || [],
);

const reorderableStates = computed({
  get() {
    return answerStates.value.filter((s: StateViewModel) => s.component !== 'GoTo');
  },
  set(newOrder: StateViewModel[]) {
    // Preserve GoTo states
    const goToStates = answerStates.value.filter((s: StateViewModel) => s.component === 'GoTo');
    // Update answerStates with new order followed by GoTo states
    answerStates.value = [...newOrder, ...goToStates];

    onAnswerChange();
  },
});

const validations = {
  faqName: {
    required,
    validIntentName,
  },
  answerStates: {
    required,
  },
  intent: {
    required,
  },
  questions: {
    required,
  },
};

const $v = useVuelidate(validations, { faqName, answerStates, intent, questions });

const faqNameErrorText = computed(() => {
  const vuelidateFaqNameField = $v.value.faqName;

  if (vuelidateFaqNameField.$error && vuelidateFaqNameField.required && !vuelidateFaqNameField.validIntentName) {
    return 'Must not contain &lt;, &gt;, *, %, &amp;, :, \\, $';
  }
  return '';
});

const previewFlowHoverMessage = computed(() =>
  hasMadeChanges.value ? 'Cannot preview an FAQ with unsaved changes' : '',
);
const saveAnswerHoverMessage = computed(() => (!hasMadeChanges.value ? 'No changes to save' : ''));

const makeLiveHoverMessage = computed(() => {
  if (isAnswerTransitioningToAnInactiveFlow.value) {
    return 'Must not transition to flow that is not live';
  }
  if (hasMadeChanges.value) {
    return 'Cannot make FAQ live with unsaved changes';
  }
  return '';
});

const isPreviewButtonEnabled = computed(() => !hasMadeChanges.value && !isSaveInProgress.value && intentId.value);

const pauseAnswerErrorMessage = computed(() => {
  if (hasLiveParentFlows.value) {
    return 'Cannot pause an FAQ that is transitioned to by a live flow';
  }
  if (hasMadeChanges.value) {
    return 'Cannot pause an FAQ with unsaved changes';
  }
  return '';
});

const isSaveButtonEnabled = computed(() => !isSaveInProgress.value && hasMadeChanges.value);
const canMakeLive = computed(
  () =>
    !hasMadeChanges.value &&
    !isSaveInProgress.value &&
    isBotStudioEnabled() &&
    intentId.value &&
    !isAnswerTransitioningToAnInactiveFlow.value,
);
const canPauseAnswer = computed(
  () => currentAnswerStatus.value === FlowStatus.Live && !hasLiveParentFlows.value && !hasMadeChanges.value,
);
const canDeleteAnswer = computed(() => !hasLiveParentFlows.value);
const answerId = computed(() => <string>route.params.id);

onMounted(() => Promise.all([fetchAnswer(), fetchIntents()]));
onBeforeUnmount(() => (navigationNext = null));

function onAnswerChange() {
  hasMadeChanges.value = true;
}

async function saveAnswer() {
  $v.value.$touch();

  if ($v.value.$invalid || answerStates.value.some((s) => s.invalid)) {
    Toast.showError('Fix the errors in red before saving');
    return;
  }
  try {
    appInsights.trackEvent(
      { name: 'Save answer clicked' },
      { answerId: answerId.value, workspaceId: currentWorkspace.value.id },
    );
    isSaveInProgress.value = true;
    faqName.value = faqName.value.trim();

    if (!intentId.value) {
      await createNewIntent();
    } else {
      await updateExistingIntent();
    }

    await updateAnswer(answerId.value!, {
      title: faqName.value,
      intentId: intentId.value!,
      answerStates: answerStates.value,
      status: currentAnswerStatus.value,
    });

    hasMadeChanges.value = false;
    Toast.showSuccess('Saved FAQ');
  } catch (ex: any) {
    Toast.showError(ex.message);
  } finally {
    isSaveInProgress.value = false;
  }
}

function openPreview() {
  appInsights.trackEvent(
    { name: 'Preview clicked' },
    { answerId: answerId.value, workspaceId: currentWorkspace.value.id },
  );
  showBotPreviewModal.value = true;
}

function showMakeAnswerLiveConfirmation() {
  appInsights.trackEvent(
    { name: 'Make live clicked' },
    { answerId: answerId.value, workspaceId: currentWorkspace.value.id },
  );
  showMakeLiveModal.value = true;
}

function upgradeButtonClicked() {
  showUpgradeModal.value = true;
}

function deleteAnswer() {
  if (!canDeleteAnswer.value) {
    Toast.showError('Cannot delete an FAQ that is transitioned to by another flow');
  } else {
    showDeleteModal.value = true;
  }
}

function handleBackNavigation() {
  window.setTimeout(() => {
    router.push({ name: 'bots-answers' });
  }, 100); // Wait for DOM/state updates to complete, next tick doesn't do it as the browser needs to un-focus on a potential input
}

onBeforeRouteLeave((to, from, next) => {
  if (hasMadeChanges.value) {
    setupLeaveModal(next);
  } else {
    next();
  }
});

function setupLeaveModal(next: (value?: boolean) => void) {
  showLeaveModal.value = true;
  navigationNext = next;
}

async function discardAnswer() {
  showLeaveModal.value = false;
  if (navigationNext) {
    navigationNext(true); // Proceed with navigation
    navigationNext = null; // Clear after use
  }
}

function pauseAnswer() {
  appInsights.trackEvent(
    { name: 'Pause answer clicked' },
    { answerId: answerId.value, workspaceId: currentWorkspace.value.id },
  );
  if (!canPauseAnswer.value) {
    Toast.showError(pauseAnswerErrorMessage.value);
    return;
  }
  showPauseAnswerModal.value = true;
}

async function makeAnswerLive() {
  try {
    isSaveInProgress.value = true;
    const savedAnswer = await updateAnswer(answerId.value, {
      status: FlowStatus.Live,
    });
    currentAnswerStatus.value = savedAnswer.status;
    appInsights.trackEvent(
      { name: 'Made answer live' },
      { answerId: answerId.value, workspaceId: currentWorkspace.value.id },
    );
    Toast.showSuccess(`Made FAQ ${faqName.value} live`);
  } catch (error) {
    Toast.showError(`Failed to make FAQ ${faqName.value} live`);
  }
  isSaveInProgress.value = false;
  showMakeLiveModal.value = false;
}

async function onDeleteAnswerConfirmed() {
  showDeleteModal.value = false;
  try {
    appInsights.trackEvent(
      { name: 'Delete answer clicked' },
      { answerId: answerId.value, workspaceId: currentWorkspace.value.id },
    );
    await answersApi.deleteAnswer(currentWorkspace.value.id, answerId.value);
    hasMadeChanges.value = false;
    await router.push({ name: 'bots-answers' });
    Toast.showSuccess('Deleted FAQ');
  } catch (ex: any) {
    Toast.showError('Failed to delete FAQ : ' + ex.message);
  }
}

async function onPauseAnswerConfirmed() {
  try {
    isSaveInProgress.value = true;
    const savedAnswer = await updateAnswer(answerId.value, {
      status: FlowStatus.Paused,
    });
    currentAnswerStatus.value = savedAnswer.status;
    appInsights.trackEvent(
      { name: 'Answer paused' },
      { answerId: answerId.value, workspaceId: currentWorkspace.value.id },
    );
    Toast.showSuccess(`Paused ${faqName.value}`);
  } catch (error) {
    Toast.showError(`Failed to pause FAQ ${faqName.value}`);
  }
  isSaveInProgress.value = false;
  showPauseAnswerModal.value = false;
}

function getDeleteAnswerConfirmationMessage() {
  return `Are you sure you want to delete the <b>${HtmlFormatter.escapeHtmlCharacters(faqName.value)}</b> FAQ? The action is irreversible. Please type the name of the FAQ to confirm:`;
}

function setFaqName(text: string, previousValue: string) {
  if (text !== previousValue) {
    faqName.value = text;
    onAnswerChange();
  }
}

const getStateComponent = (state: StateViewModel) => {
  const name = `${state.component}Component`;
  return (COMPONENTS as any)[name] || name;
};

function addMessageState() {
  addState({
    id: `state-${nanoid(7)}`,
    component: 'Text',
    text: '',
  });
  onAnswerChange();
}

function addAppIntegrationState() {
  addState({
    id: `state-${nanoid(7)}`,
    component: 'AppIntegration',
  });
  onAnswerChange();
}

function addGoToState() {
  answerStates.value.push({
    id: `state-${nanoid(7)}`,
    component: 'GoTo',
    transition: {
      type: undefined,
      payload: undefined,
    },
    invalid: true,
  });
  onAnswerChange();
}

function deleteState(state: StateViewModel) {
  answerStates.value = answerStates.value.filter((s) => s.id !== state.id);
  onAnswerChange();
}

function stateUpdated(state: StateViewModel) {
  const index = answerStates.value.findIndex((s) => s.id === state.id);
  answerStates.value[index] = state;
  onAnswerChange();
}

function clearTransform(event: any) {
  // this is a fix for the modal within a state not appearing correctly after the state is dragged
  // the modal is position:fixed which can be relative to a parent that has a transform style, which we don't want.
  // see https://github.com/SortableJS/Sortable/issues/1687
  event.item.style.transform = null;
}

function setIsStatePickerUp(val: boolean) {
  isStatePickerUp.value = val;
}

function isMakeLiveButtonVisible() {
  return isStatus(FlowStatus.Paused, FlowStatus.Draft);
}

function isPauseOptionVisible() {
  return isStatus(FlowStatus.Live);
}

function getLeaveConfirmationMessage() {
  return `All changes you've made to <b>${HtmlFormatter.escapeHtmlCharacters(faqName.value)}</b> will be discarded. <br/>Are you sure you want to leave the page?`;
}

function getMakeLiveConfirmationMessage() {
  return `This will make the FAQ active to your audience. Are you sure you want to continue?`;
}

function getPauseConfirmationMessage() {
  return `This will prevent the FAQ from being triggered. Are you sure you want to continue?`;
}

function isBotStudioEnabled() {
  return isWorkspaceFeatureEnabled(BOT_STUDIO_ENABLED).value;
}

async function handleIntentChange(changedIntent: Partial<IntentListItemViewModel>) {
  const hasChangedIntent = changedIntent.id !== intentId.value && changedIntent.title !== intent.value?.title;
  const isInitialChangeToFaqNameIntent = !intent.value && changedIntent.title === faqName.value;
  if (hasChangedIntent && !isInitialChangeToFaqNameIntent) {
    onAnswerChange();
  }
  if (intentId.value !== changedIntent.id) {
    questions.value = [{ id: nanoid(7), text: '' }];
  }
  intent.value = changedIntent;
  intentId.value = changedIntent.id!;
  loadedFullIntent.value = false;
  await loadFullIntent();
  loadedFullIntent.value = true;
}

async function loadFullIntent() {
  if (!intentId.value) {
    return;
  }
  intent.value = await getIntent(intentId.value);
  questions.value = intent.value.utterances || [{ id: nanoid(7), text: '' }];
}

function containsGoToState() {
  return answerStates.value?.some((s) => s.component === 'GoTo');
}

async function fetchAnswer() {
  existingAnswer.value = await loadAnswer(answerId.value);
  intentId.value = existingAnswer.value.intentId;
  faqName.value = existingAnswer.value.title;

  answerStates.value = existingAnswer.value.answerStates.map((s) => {
    s.id = `state-${nanoid(7)}`;
    return s;
  });

  hasLiveParentFlows.value = existingAnswer.value.parentFlowIds && existingAnswer.value.parentFlowIds.length > 0;
  currentAnswerStatus.value = existingAnswer.value.status;
  if (answerStates.value.length === 0) {
    addMessageState();
  }

  loadedAnswer.value = true;

  await nextTick(() => {
    hasMadeChanges.value = false;
  });
}

async function fetchIntents() {
  intents.value = await loadIntents(true);
  loadedIntentList.value = true;
}

function isStatus(...allowedStatuses: FlowStatus[]): boolean {
  return allowedStatuses.includes(currentAnswerStatus.value);
}

async function createNewIntent() {
  if (!intent.value || !intent.value.title) {
    return;
  }
  const newIntent = await createIntent({
    title: intent.value.title,
    utterances: questions.value.map((q) => q.text),
  });
  intentId.value = newIntent.id;
}

async function updateExistingIntent() {
  if (!intent.value || !intent.value.title) {
    return;
  }
  await updateIntent(intentId.value!, {
    title: intent.value.title,
    utterances: questions.value.map((q) => q.text),
  });
}

function addState(state: StateViewModel): void {
  if (endStates.value.length > 0) {
    answerStates.value.splice(answerStates.value.length - 1, 0, state);
    return;
  }
  answerStates.value.push(state);
}

return (_ctx: any,_cache: any) => {
  const _component_n_loading_spinner = _resolveComponent("n-loading-spinner")!
  const _component_n_tooltip = _resolveComponent("n-tooltip")!
  const _component_n_badge = _resolveComponent("n-badge")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (showBotPreviewModal.value)
      ? (_openBlock(), _createBlock(BotPreviewModal, {
          key: 0,
          id: "answer-preview-modal",
          onCancel: _cache[0] || (_cache[0] = ($event: any) => (showBotPreviewModal.value = false)),
          answerToPreview: answerId.value
        }, null, 8, ["answerToPreview"]))
      : _createCommentVNode("", true),
    (!loadedAnswer.value || !loadedIntentList.value)
      ? (_openBlock(), _createBlock(_component_n_loading_spinner, { key: 1 }))
      : _createCommentVNode("", true),
    (loadedAnswer.value && loadedIntentList.value)
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
          _createElementVNode("nav", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                class: "back-arrow",
                onClick: handleBackNavigation
              }, [
                _createVNode(BackArrow, { class: "icon-1-5x" })
              ]),
              _createElementVNode("h4", _hoisted_5, [
                _createVNode(_component_n_tooltip, {
                  position: "bottom",
                  text: faqNameErrorText.value
                }, {
                  default: _withCtx(() => [
                    _createVNode(EditableText, {
                      class: _normalizeClass({ invalid: _unref($v).faqName.$error }),
                      placeholder: "Enter the Frequently Asked Question...",
                      ref: "titleInput",
                      value: faqName.value,
                      onTextUpdated: setFaqName,
                      minWidth: "100px",
                      maxWidth: "600px"
                    }, null, 8, ["class", "value"])
                  ]),
                  _: 1
                }, 8, ["text"]),
                _createElementVNode("div", _hoisted_6, [
                  (currentAnswerStatus.value === 'live')
                    ? (_openBlock(), _createBlock(_component_n_badge, {
                        key: 0,
                        variant: "success"
                      }, {
                        default: _withCtx(() => _cache[17] || (_cache[17] = [
                          _createTextVNode("Live")
                        ])),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (currentAnswerStatus.value === 'paused')
                    ? (_openBlock(), _createBlock(_component_n_badge, {
                        key: 1,
                        variant: "secondary"
                      }, {
                        default: _withCtx(() => _cache[18] || (_cache[18] = [
                          _createTextVNode("Paused")
                        ])),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (currentAnswerStatus.value === 'draft')
                    ? (_openBlock(), _createBlock(_component_n_badge, {
                        key: 2,
                        variant: "default"
                      }, {
                        default: _withCtx(() => _cache[19] || (_cache[19] = [
                          _createTextVNode("Draft")
                        ])),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("p", _hoisted_8, [
                _createVNode(_component_n_tooltip, {
                  position: "bottom",
                  text: saveAnswerHoverMessage.value
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_button, {
                      id: "save-button",
                      variant: "secondary",
                      disabled: !isSaveButtonEnabled.value,
                      loading: isSaveInProgress.value,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (saveAnswer()))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode(SaveIcon),
                          _cache[20] || (_cache[20] = _createTextVNode(" Save Changes "))
                        ])
                      ]),
                      _: 1
                    }, 8, ["disabled", "loading"])
                  ]),
                  _: 1
                }, 8, ["text"])
              ]),
              _createElementVNode("p", _hoisted_10, [
                _createVNode(_component_n_tooltip, {
                  position: "bottom",
                  text: previewFlowHoverMessage.value
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_button, {
                      variant: "secondary--outline",
                      disabled: !isPreviewButtonEnabled.value,
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (openPreview())),
                      id: "preview-bot-button"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(PlayIcon),
                          _cache[21] || (_cache[21] = _createTextVNode(" Preview "))
                        ])
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _: 1
                }, 8, ["text"])
              ]),
              (isMakeLiveButtonVisible() && !isBotStudioEnabled())
                ? (_openBlock(), _createBlock(AdvancedTooltip, {
                    key: 0,
                    class: "level-item"
                  }, {
                    element: _withCtx(() => [
                      _createElementVNode("p", null, [
                        _createVNode(_component_n_button, {
                          variant: "success",
                          disabled: !canMakeLive.value,
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (showMakeAnswerLiveConfirmation())),
                          id: "make-live-button"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_12, [
                              _createVNode(PlayIcon),
                              _cache[22] || (_cache[22] = _createTextVNode(" Make Live"))
                            ])
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ])
                    ]),
                    content: _withCtx(() => _cache[23] || (_cache[23] = [
                      _createElementVNode("div", null, [
                        _createElementVNode("strong", null, "Upgrade to unlock this feature")
                      ], -1),
                      _createElementVNode("div", null, "Get flows, FAQs and more", -1)
                    ])),
                    footer: _withCtx(() => [
                      _createElementVNode("button", {
                        class: "button is-primary is-outlined is-fullwidth",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (upgradeButtonClicked()))
                      }, " Upgrade ")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("p", _hoisted_13, [
                (isMakeLiveButtonVisible() && isBotStudioEnabled())
                  ? (_openBlock(), _createBlock(_component_n_tooltip, {
                      key: 0,
                      position: "bottom",
                      text: makeLiveHoverMessage.value
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_n_button, {
                          variant: "success",
                          disabled: !canMakeLive.value,
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (showMakeAnswerLiveConfirmation())),
                          id: "make-live-button"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_14, [
                              _createVNode(PlayIcon),
                              _cache[24] || (_cache[24] = _createTextVNode(" Make Live "))
                            ])
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ]),
                      _: 1
                    }, 8, ["text"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("p", _hoisted_15, [
                _createVNode(DropDownMenu, {
                  goLeft: true,
                  useColourOnActive: true
                }, {
                  default: _withCtx(() => [
                    (isPauseOptionVisible())
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          onClick: pauseAnswer,
                          class: "dropdown-item",
                          id: "pause-answer-option"
                        }, [
                          _createVNode(PauseIcon),
                          _cache[25] || (_cache[25] = _createTextVNode("Pause FAQ"))
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("a", {
                      onClick: deleteAnswer,
                      class: "dropdown-item",
                      id: "delete-answer-option"
                    }, [
                      _createVNode(DeleteIcon),
                      _cache[26] || (_cache[26] = _createTextVNode("Delete"))
                    ])
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (loadedAnswer.value && loadedIntentList.value)
      ? (_openBlock(), _createElementBlock("section", {
          key: 3,
          class: _normalizeClass(["section content-container", { 'is-disabled': isSaveInProgress.value }])
        }, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _cache[28] || (_cache[28] = _createElementVNode("div", { class: "sub-heading sub-heading-left" }, [
                _createElementVNode("h5", { class: "title is-6" }, "Frequently Asked Question")
              ], -1)),
              _createElementVNode("div", _hoisted_18, [
                _createVNode(FaqIntentPicker, {
                  faqName: faqName.value,
                  intentId: intentId.value,
                  onInput: handleIntentChange,
                  intents: intents.value
                }, null, 8, ["faqName", "intentId", "intents"]),
                (!loadedFullIntent.value)
                  ? (_openBlock(), _createBlock(_component_n_loading_spinner, { key: 0 }))
                  : _createCommentVNode("", true),
                (loadedFullIntent.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _cache[27] || (_cache[27] = _createElementVNode("h2", null, [
                        _createElementVNode("strong", null, "Example Utterances")
                      ], -1)),
                      _createVNode(UtteranceList, {
                        modelValue: questions.value,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((questions).value = $event)),
                        term: "utterance",
                        "is-editable": !isSaveInProgress.value,
                        onInput: onAnswerChange
                      }, null, 8, ["modelValue", "is-editable"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _cache[32] || (_cache[32] = _createElementVNode("div", { class: "sub-heading sub-heading-right" }, [
                _createElementVNode("h5", { class: "title is-6" }, "Answer")
              ], -1)),
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_unref(Draggable), {
                  modelValue: reorderableStates.value,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((reorderableStates).value = $event)),
                  class: "state-list",
                  handle: ".island-badge",
                  onEnd: clearTransform,
                  "item-key": "id"
                }, {
                  item: _withCtx(({ element: state }) => [
                    (_openBlock(), _createElementBlock("div", {
                      class: "state",
                      key: state.id
                    }, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(getStateComponent(state)), {
                        value: state,
                        onStateUpdated: stateUpdated
                      }, null, 40, ["value"])),
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("a", {
                          class: "delete is-small delete-state",
                          onClick: ($event: any) => (deleteState(state))
                        }, null, 8, _hoisted_23)
                      ])
                    ]))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(DropDownMenu, {
                  class: _normalizeClass(["add-state-container", { 'is-up': isStatePickerUp.value }]),
                  dropDownIcon: "big-add-circle",
                  onIsUp: setIsStatePickerUp
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("a", {
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (addMessageState())),
                      class: "dropdown-item"
                    }, [
                      _createVNode(TextIcon),
                      _cache[29] || (_cache[29] = _createTextVNode(" Message "))
                    ]),
                    _createElementVNode("a", {
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (addAppIntegrationState())),
                      class: "dropdown-item"
                    }, [
                      _createElementVNode("span", _hoisted_24, [
                        _createVNode(_component_font_awesome_icon, { icon: "cube" })
                      ]),
                      _cache[30] || (_cache[30] = _createTextVNode(" App Action "))
                    ]),
                    (!containsGoToState())
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          onClick: _cache[10] || (_cache[10] = ($event: any) => (addGoToState())),
                          class: "dropdown-item"
                        }, [
                          _createVNode(GoToIcon),
                          _cache[31] || (_cache[31] = _createTextVNode(" Go To "))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["class"]),
                (_unref($v).answerStates.$error && !_unref($v).answerStates.required)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_25, " You must add an answer "))
                  : _createCommentVNode("", true),
                (containsGoToState())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(endStates.value, (state) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "state",
                          key: state.id
                        }, [
                          (_openBlock(), _createBlock(_resolveDynamicComponent(getStateComponent(state)), {
                            value: state,
                            onStateUpdated: stateUpdated
                          }, null, 40, ["value"])),
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("a", {
                              class: "delete is-small delete-state",
                              onClick: ($event: any) => (deleteState(state))
                            }, null, 8, _hoisted_28)
                          ])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ], 2))
      : _createCommentVNode("", true),
    (showLeaveModal.value)
      ? (_openBlock(), _createBlock(ConfirmationModal, {
          key: 4,
          id: "discard-changes-modal",
          ref_key: "discardModal",
          ref: discardModal,
          confirmationTitle: "Discard Changes",
          confirmationMessage: getLeaveConfirmationMessage(),
          onConfirm: discardAnswer,
          onCancel: _cache[11] || (_cache[11] = ($event: any) => (showLeaveModal.value = false))
        }, null, 8, ["confirmationMessage"]))
      : _createCommentVNode("", true),
    (showMakeLiveModal.value)
      ? (_openBlock(), _createBlock(ConfirmationModal, {
          key: 5,
          id: "make-live-modal",
          confirmationTitle: "Make Live",
          confirmationMessage: getMakeLiveConfirmationMessage(),
          onConfirm: makeAnswerLive,
          onCancel: _cache[12] || (_cache[12] = ($event: any) => (showMakeLiveModal.value = false))
        }, null, 8, ["confirmationMessage"]))
      : _createCommentVNode("", true),
    (showPauseAnswerModal.value)
      ? (_openBlock(), _createBlock(ConfirmationModal, {
          key: 6,
          id: "pause-answer-modal",
          confirmationTitle: "Pause FAQ",
          confirmationMessage: getPauseConfirmationMessage(),
          onConfirm: onPauseAnswerConfirmed,
          onCancel: _cache[13] || (_cache[13] = ($event: any) => (showPauseAnswerModal.value = false))
        }, null, 8, ["confirmationMessage"]))
      : _createCommentVNode("", true),
    (showDeleteModal.value)
      ? (_openBlock(), _createBlock(ConfirmationModal, {
          key: 7,
          id: "delete-modal",
          confirmationTitle: "Delete FAQ",
          confirmationMessage: getDeleteAnswerConfirmationMessage(),
          typeConfirmationValidationMessage: faqName.value,
          confirmButtonLabel: "Delete",
          onConfirm: _cache[14] || (_cache[14] = ($event: any) => (onDeleteAnswerConfirmed())),
          onCancel: _cache[15] || (_cache[15] = ($event: any) => (showDeleteModal.value = false))
        }, null, 8, ["confirmationMessage", "typeConfirmationValidationMessage"]))
      : _createCommentVNode("", true),
    (showUpgradeModal.value)
      ? (_openBlock(), _createBlock(UpgradeModal, {
          key: 8,
          onClose: _cache[16] || (_cache[16] = ($event: any) => (showUpgradeModal.value = false))
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})